import React from 'react'
import './navigator.css';
import './menuitem.css';
import './usermenu.css';
import { GrUser } from "react-icons/gr";
import { MdLogout } from "react-icons/md";
import { IoMdKey } from "react-icons/io";
import { FaCoins } from "react-icons/fa";
import { AuthorizeDialog } from "../dialogs/authorizedialog";
import { IState } from '../chatbot/api/llmapi';
import { MenuItem } from './menuitem';
import { Users } from '../fasades/users';
import { useNavigate, NavigateFunction } from 'react-router-dom';
import { Conversation } from '../fasades/conversation';
import { PayCheckoutDialog } from '../landingpage/pay';

interface Props {
    state : IState;
    onRegisterCloseDropdown?: (fn: () => void) => void;
    onBeforeOpen?: () => void;
}

interface PropsNav extends Props {
    navigate: NavigateFunction;
}

interface State {
    show : boolean,
    credits?: number
}

class UserMenu extends React.Component<PropsNav, State> {
    unsubscribe?: () => void;

    constructor(props : PropsNav)
    {
        super(props);

        this.state = {
            show : false
        }
    }

    componentDidMount(): void {
        this.props.onRegisterCloseDropdown?.(() => this.setState({ show : false }));
    }

    componentDidUpdate(): void {
        if (this.unsubscribe === undefined) {
            this.unsubscribe = Conversation.subscribeToCredit((credit: number) => {
                this.setState({credits: credit})
            });
        }
    }

    componentWillUnmount(): void {
        if (this.unsubscribe !== undefined) {
            this.unsubscribe();
        }
    }

    handleSignIn()
    {
        AuthorizeDialog.showDialog();
    }

    handleLogout()
    {
        Users.logout();
        this.props.navigate!('/');
    }

    handleBuyCredits()
    {
        PayCheckoutDialog.showDialog();
    }

    handleAPIKeys()
    {
        this.props.navigate!('/playground/apikeys');
    }

    handleClick()
    {
        if (!this.state.show) {
            this.props.onBeforeOpen?.();
        }
        this.setState(prev => ({ show : !prev.show }));
    }

    render() {
        return (
            <>
                 { this.props.state.user === undefined && (
                <div className="sign-in">
                    <button onClick= { () => this.handleSignIn() }>
                    { React.createElement(GrUser as React.ComponentType) }
                        <span>Sign In</span>
                    </button>
                </div>
                )}
                { this.props.state.user !== undefined && (
                 <ul className="usermenu">
                   <li
                     onClick={ () => this.handleClick()} 
                     onMouseEnter={() => { this.setState({show : true}); Users.getUserCredits().then(credits => this.setState({credits})); } }
                     onMouseLeave={() => { this.setState({show : false})} } >
                     <div className="user">
                        { React.createElement(GrUser as React.ComponentType) }
                        <div className="menu-link user-item">{ this.props.state.user?.email }</div>
                     </div>
                     { this.state.show &&
                     <ul className="user-dropdown">
                        <MenuItem icon={ IoMdKey } onSelect={()=>{ this.handleAPIKeys() }}>API keys</MenuItem>
                        <MenuItem icon={ FaCoins } onSelect={()=>{ this.handleBuyCredits() }}>Buy credits</MenuItem>
                        <MenuItem icon={ MdLogout } onSelect={()=>{ this.handleLogout() }}>Logout</MenuItem>
                        {this.state.credits !== undefined && (
                            <li className="credits">
                                <div>
                                    <span>Credits: ${this.state.credits}</span>
                                </div>
                            </li>
                        )}
                     </ul>
                     }
                   </li>
                </ul>
                )}
           </>
        );
    }
}

function withNavigate<P extends object>(Component: React.ComponentType<P & { navigate: NavigateFunction }>) {
    return (props: P) => <Component {...props} navigate={useNavigate()} />;
}

export default withNavigate<Props>(UserMenu);

